import {
  Megaphone, Gift, Star, Heart, ShoppingBag,
  Sparkles, Zap, Trophy, PartyPopper, Rocket,
  type LucideIcon,
} from 'lucide-react';

export interface AdIconPreset {
  id: string;
  label: string;
  icon: LucideIcon;
  bgColor: string;
  iconColor: string;
}

export const AD_ICON_PRESETS: AdIconPreset[] = [
  { id: 'megaphone', label: '메가폰', icon: Megaphone, bgColor: '#F4F4F5', iconColor: '#71717A' },
  { id: 'gift', label: '선물', icon: Gift, bgColor: '#F3E8FF', iconColor: '#A855F7' },
  { id: 'star', label: '별', icon: Star, bgColor: '#FEF9C3', iconColor: '#EAB308' },
  { id: 'heart', label: '하트', icon: Heart, bgColor: '#FCE7F3', iconColor: '#EC4899' },
  { id: 'shopping-bag', label: '쇼핑백', icon: ShoppingBag, bgColor: '#DCFCE7', iconColor: '#22C55E' },
  { id: 'sparkles', label: '반짝', icon: Sparkles, bgColor: '#DBEAFE', iconColor: '#3B82F6' },
  { id: 'zap', label: '번개', icon: Zap, bgColor: '#FFEDD5', iconColor: '#F97316' },
  { id: 'trophy', label: '트로피', icon: Trophy, bgColor: '#FEF3C7', iconColor: '#F59E0B' },
  { id: 'party-popper', label: '파티', icon: PartyPopper, bgColor: '#FFE4E6', iconColor: '#F43F5E' },
  { id: 'rocket', label: '로켓', icon: Rocket, bgColor: '#E0E7FF', iconColor: '#6366F1' },
];

export const getAdIconPreset = (iconType: string | null | undefined): AdIconPreset =>
  AD_ICON_PRESETS.find(p => p.id === iconType) ?? AD_ICON_PRESETS[0];
